































import Vue from "vue";

/**
 * @Emits open if an element opens
 * @Emits clsoe if an element closes
 */
export default Vue.extend({
  name: "FieldCollapse",
  props: {
    /** index of the open element */
    value: {
      type: Number,
      default: 0,
    },
    /** array of elements for each field */
    data: {
      type: Array as () => Array<any>,
      required: true,
    },
    /** should all elements be open */
    allOpen: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isOpen: this.value,
    };
  },
  watch: {
    value() {
      this.isOpen = this.value;
    },
    isOpen() {
      this.$emit("input", this.isOpen);
    },
  },
  methods: {
    onOpen(index: number) {
      this.isOpen = index;
      this.$emit("open", index);
    },
    onClose(index: number) {
      this.isOpen = -1;
      this.$emit("close", index);
    },
  },
});
